export const MODULE_NAME = 'Home'

export const paths = {
  home: '/',
}
